function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M93 141.999C144.362 141.999 186 132.303 186 120.343C186 108.383 144.362 98.6875 93 98.6875C41.6375 98.6875 0 108.383 0 120.343C0 132.303 41.6375 141.999 93 141.999Z",
  fill: "#F1F1F1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.8492 40.9414L35.4404 60.1191L117.513 70.2466L149.645 49.1383L74.8492 40.9414Z",
  fill: "#2C4756"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.4404 60.1191V112.912L116.35 129.073L117.513 70.0312L35.4404 60.1191Z",
  fill: "#5A6D78"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.365 98.0439L116.35 129.073L117.513 70.247L149.644 49.1387L149.365 98.0439Z",
  fill: "#7B8D97"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.406 67.4458L149.645 49.1387L117.513 70.2471L141.228 93.0879L175.406 67.4458Z",
  fill: "#9BA5AA"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M133.555 59.6878C130.067 41.372 118.675 36.6315 120.535 20.9015C120.928 17.5766 123.325 10.343 121.465 3.44767C113.095 13.7907 89.1474 12.9288 78.9174 0C74.9649 9.26561 76.5924 12.9288 77.9874 18.9622C81.6516 34.8107 68.4549 39.6482 64.0374 63.5664L117.512 70.2463L133.555 59.6878Z",
  fill: "#D9D4CC"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M92.8379 24.8341C94.0106 24.8341 94.9612 23.9531 94.9612 22.8663C94.9612 21.7795 94.0106 20.8984 92.8379 20.8984C91.6653 20.8984 90.7147 21.7795 90.7147 22.8663C90.7147 23.9531 91.6653 24.8341 92.8379 24.8341Z",
  fill: "#2C4756"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M95.8894 27.1514C97.7494 26.7958 99.6792 26.7549 101.702 27.1514C101.004 31.03 96.1219 30.1681 95.8894 27.1514Z",
  fill: "#2C4756"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M104.071 27.6811L114.745 26.2331C114.84 26.2223 114.91 26.1404 114.896 26.0499C114.884 25.9615 114.796 25.8969 114.699 25.9099L103.982 27.0476C103.794 27.0713 103.662 27.2307 103.685 27.4053C103.711 27.5798 103.883 27.7026 104.071 27.6811Z",
  fill: "#9BA5AA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M104.005 28.6475L117.265 29.2353C117.362 29.2418 117.447 29.1715 117.455 29.0789C117.46 28.986 117.387 28.9061 117.289 28.9019L104.052 27.9939C103.862 27.9835 103.697 28.12 103.685 28.3011C103.673 28.48 103.815 28.6349 104.005 28.6475Z",
  fill: "#9BA5AA"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M103.462 29.6253L113.727 32.4763C113.819 32.5053 113.92 32.4559 113.95 32.3668C113.98 32.2776 113.93 32.1832 113.839 32.1569L103.677 29.0004C103.496 28.9457 103.301 29.0434 103.242 29.2151C103.183 29.3891 103.28 29.5727 103.462 29.6253Z",
  fill: "#9BA5AA"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.6204 27.155L82.9043 26.0173C82.8066 26.0043 82.7184 26.069 82.7067 26.1573C82.6928 26.2478 82.7626 26.3297 82.8579 26.3405L93.5318 27.7885C93.7202 27.8101 93.8922 27.6872 93.9178 27.5127C93.9411 27.3381 93.8087 27.1787 93.6204 27.155Z",
  fill: "#9BA5AA"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.5555 28.1032L80.3183 29.0112C80.2207 29.0155 80.1476 29.0954 80.1529 29.1882C80.1606 29.2809 80.2453 29.3511 80.3427 29.3447L93.6028 28.7568C93.7929 28.7443 93.9351 28.5894 93.9228 28.4105C93.9102 28.2294 93.7459 28.0929 93.5555 28.1032Z",
  fill: "#9BA5AA"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.9161 29.1039L83.7543 32.2599C83.6634 32.2862 83.6134 32.3807 83.6435 32.4698C83.6735 32.5589 83.7739 32.6083 83.8665 32.5793L94.1314 29.7288C94.3133 29.6762 94.4102 29.4926 94.3513 29.3187C94.293 29.1469 94.0974 29.0492 93.9161 29.1039Z",
  fill: "#9BA5AA"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M104.754 24.8341C105.927 24.8341 106.878 23.9531 106.878 22.8663C106.878 21.7795 105.927 20.8984 104.754 20.8984C103.582 20.8984 102.631 21.7795 102.631 22.8663C102.631 23.9531 103.582 24.8341 104.754 24.8341Z",
  fill: "#2C4756"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.4518 29.769C98.5355 30.5189 98.2658 31.3377 97.6172 31.9324C97.0731 32.4324 96.2687 32.775 95.1923 32.8051C95.0946 32.8051 95.0156 32.8784 95.0156 32.9689C95.0156 33.0594 95.0946 33.1327 95.1923 33.1327C96.4036 33.165 97.3242 32.8159 97.9752 32.288C98.8053 31.6114 99.1821 30.6331 99.1402 29.7238C99.1263 29.5492 98.961 29.4157 98.7704 29.4286C98.582 29.4415 98.4402 29.5945 98.4518 29.769Z",
  fill: "#2C4756"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.5679 29.7238C98.526 30.6331 98.9029 31.6114 99.7329 32.288C100.384 32.8159 101.305 33.165 102.516 33.1327C102.614 33.1327 102.693 33.0594 102.693 32.9689C102.693 32.8784 102.614 32.8051 102.516 32.8051C101.439 32.775 100.635 32.4324 100.091 31.9324C99.4423 31.3377 99.1726 30.5189 99.2563 29.769C99.2679 29.5945 99.1261 29.4415 98.9378 29.4286C98.7471 29.4157 98.5818 29.5492 98.5679 29.7238Z",
  fill: "#2C4756"
});

var SvgBoxCat = function SvgBoxCat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 142,
    viewBox: "0 0 186 142",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoxCat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BoxCat.b1e2fda8.svg";
export { ForwardRef as ReactComponent };